import React from "react";
import { userCan } from "../../helpers/User";
import { connect } from "react-redux";

/**
 * Private component will display based on permissions
 * - As represent component to load under allowed permissions for user
 * - Or is fallback component if failed access
 * - permissions[] are string permissions to check for user
 *
 * @param props
 * @returns {*}
 * @constructor
 */
const Private = props => {
  // Remove dispatch from props
  const {
    As,
    checkUser,
    dispatch,
    Or = null,
    permissions = [],
    ...remainingProps
  } = props;

  if (checkUser(permissions)) {
    return <As {...remainingProps} />;
  }

  if (Or) {
    return <Or {...remainingProps} />;
  }

  return null;
};

const mapStateToProps = ({ auth }) => ({
  checkUser: permissions => {
    return userCan(auth, permissions);
  }
});

export default connect(mapStateToProps)(Private);



// WEBPACK FOOTER //
// ./src/components/Private/Private.js